const storageEngine = () => {
    try {
        const storage = window['localStorage']

        const x = '__storage_test__'

        storage.setItem(x, x)
        storage.removeItem(x)

        return storage
    } catch(e) {
        console.warn('localStorage support not found, Settings functionality will not be available')
        return false
    }
}

export {storageEngine}
